const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`tag_name`] = (((context.has(`tag_name`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`tag_name`) ? context.get(`tag_name`) : null), `ul`])) : (`ul`));
                this.echo(`
`);
                if (this.compare((context.has(`tag_name`) ? context.get(`tag_name`) : null), `ul`)) {
                    this.echo(`  `);
                    context.proxy[`role`] = (((context.has(`role`))) ? (this.env.getFilter('default').traceableCallable(4, this.source)(...[(context.has(`role`) ? context.get(`role`) : null), `list`])) : (`list`));
                }
                this.echo(`
<`);
                this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(` class="o-list`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`"
  `);
                if ((context.has(`role`) ? context.get(`role`) : null)) {
                    this.echo(`role="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, (context.has(`role`) ? context.get(`role`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`>
  `);
                this.traceableDisplayBlock(9, this.source)('content', context.clone(), blocks);
                this.echo(`</`);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(`>
`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`items`) ? context.get(`items`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`      <li>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(11, this.source)(...[this.env, context.get(`item`), `html`, null, true]));
                    this.echo(`</li>
    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `c9ee7613d0fb693f461ff58c9fa22e2c69d58db16cc77061dbe2e87614973bec`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c9ee7613d0fb693f461ff58c9fa22e2c69d58db16cc77061dbe2e87614973bec`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'c9ee7613d0fb693f461ff58c9fa22e2c69d58db16cc77061dbe2e87614973bec');

let template = env.loadTemplate('c9ee7613d0fb693f461ff58c9fa22e2c69d58db16cc77061dbe2e87614973bec');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/list/list.twig", args: context }
     );
     return rendered;;
};